import { Backend } from '@/_axios';

export default {
  // list(params) {
  //   return Backend.get('/label_object_sets/', { params });
  // },

  info(projectId, labelSetId, sampleId) {
    return Backend.get(`/project/${projectId}/label_set/${labelSetId}/label_object_sets/info/${sampleId}`);
  },
  store(projectId, labelSetId, sampleId, data) {
    return Backend.post(`/project/${projectId}/label_set/${labelSetId}/label_object_sets/store/${sampleId}`, data);
  },
  get_image_polygons(projectId, labelSetId, sampleId, data) {
    return Backend.post(`/project/${projectId}/label_set/${labelSetId}/label_object_sets/get_image_polygons/${sampleId}`, data);
  },
  // editData(id) {
  //   return Backend.get(`/label_object_sets/${id}/edit`);
  // },
  // create(data) {
  //   return Backend.post('/label_object_sets/', data);
  // },
  // update(data) {
  //   return Backend.put(`/label_object_sets/${data.id}`, data);
  // },
  // delete(id) {
  //   return Backend.delete(`/label_object_sets/${id}`);
  // },
};
